import {Nullable} from "@data-force/app";
import {SyntheticEvent} from "react";
import {
    ClaimJobPhaseAction,
    ClearJobListDataAction,
    CompleteJobPhaseAction,
    DestroyConfirmClaimDialogAction,
    DestroyDetailsDrawerAction,
    GetJobListAction,
    GetJobPhaseWorkflowDefinitionsAction,
    GetPhaseConfigListAction,
    GetPhaseDirectionsAction,
    OpenCtWebJobAction,
    OpenExternalJobAction,
    OpenJobEditorAction,
    ResetActivityNotificationAction,
    SetActiveJobTypeAction,
    SetChromeExtensionMissingVisibleAction,
    SetExternalJobUrlAction,
    SetFiltersDrawerVisibilityAction,
    SetFilterTypeAction,
    SetJobListAction,
    SetJobListCursorAction,
    SetJobPhaseWorkflowDefinitionsAction,
    SetJobSearchAction,
    SetJobTestTypeAction,
    SetPhaseConfigListAction,
    SetSelectedFiltersAction,
    SetSelectedJobAction,
    SetSortDirectionAction,
    SetUnsupportedDomainVisibleAction,
    ShowActivityNotificationAction,
    ShowConfirmClaimDialogAction,
    ShowDetailsDrawerAction,
    SignResourceAction,
    ToggleInitiateWorkDialogAction,
    UpdateJobListAction,
} from "../../interfaces/store/actions/job";
import {
    ActivityNotificationData,
    ClaimJobPhase,
    CompleteJobPhase,
    JobEntity,
    JobRequestParams,
    OpenCtWebJobData,
    OpenExternalJobData,
    PhaseConfigNormalized,
    SelectedFiltersData,
} from "../../interfaces/store/actions/payload/job";
import {WorkflowDefinition} from "../../interfaces/store/actions/payload/workflowDefinition";
import {Cursor} from "../../interfaces/store/cursor";
import {
    CLAIM_JOB_PHASE,
    CLEAR_JOB_LIST_DATA,
    COMPLETE_JOB_PHASE,
    DESTROY_CONFIRM_CLAIM_DIALOG,
    DESTROY_DETAILS_DRAWER,
    GET_JOB_LIST,
    GET_JOB_PHASE_WORKFLOW_DEFINITIONS,
    GET_PHASE_CONFIG_LIST,
    GET_PHASE_DIRECTIONS,
    OPEN_CT_WEB_JOB,
    OPEN_EXTERNAL_JOB,
    OPEN_JOB_EDITOR,
    RESET_ACTIVITY_NOTIFICATION,
    SET_ACTIVE_JOB_TYPE,
    SET_CHROME_EXTENSION_MISSING_VISIBLE,
    SET_EXTERNAL_JOB_URL,
    SET_FILTER_TYPE,
    SET_FILTERS_DRAWER_VISIBILITY,
    SET_JOB_LIST,
    SET_JOB_LIST_CURSOR,
    SET_JOB_PHASE_WORKFLOW_DEFINITIONS,
    SET_JOB_SEARCH,
    SET_JOB_TEST_TYPE,
    SET_PHASE_CONFIG_LIST,
    SET_SELECTED_FILTERS,
    SET_SELECTED_JOB,
    SET_SORT_DIRECTION,
    SET_UNSUPPORTED_DOMAIN_VISIBLE,
    SHOW_ACTIVITY_NOTIFICATION,
    SHOW_CONFIRM_CLAIM_DIALOG,
    SHOW_DETAILS_DRAWER,
    SIGN_RESOURCE,
    TOGGLE_INITIATE_WORK_DIALOG,
    UPDATE_JOB_LIST,
} from "./availableActions";

export const getJobList = (payload?: JobRequestParams): GetJobListAction => ({
    type: GET_JOB_LIST,
    payload,
});

export const setJobList = (payload: JobEntity[]): SetJobListAction => ({
    type: SET_JOB_LIST,
    payload,
});

export const setSelectedJob = (payload: Nullable<JobEntity>): SetSelectedJobAction => ({
    type: SET_SELECTED_JOB,
    payload,
});

export const setJobListCursor = (payload: Nullable<Cursor>): SetJobListCursorAction => ({
    type: SET_JOB_LIST_CURSOR,
    payload,
});

export const setJobSearch = (payload: string): SetJobSearchAction => ({
    type: SET_JOB_SEARCH,
    payload,
});

export const claimJobPhase = (payload: ClaimJobPhase): ClaimJobPhaseAction => ({
    type: CLAIM_JOB_PHASE,
    payload,
});

export const completeJobPhase = (payload: CompleteJobPhase): CompleteJobPhaseAction => ({
    type: COMPLETE_JOB_PHASE,
    payload,
});

export const getJobPhaseWorkflowDefinitions = (): GetJobPhaseWorkflowDefinitionsAction => ({
    type: GET_JOB_PHASE_WORKFLOW_DEFINITIONS,
});

export const updateJobList = (payload: JobEntity[]): UpdateJobListAction => ({
    type: UPDATE_JOB_LIST,
    payload,
});

export const setJobPhaseWorkflowDefinitions = (payload: WorkflowDefinition[]): SetJobPhaseWorkflowDefinitionsAction => ({
    type: SET_JOB_PHASE_WORKFLOW_DEFINITIONS,
    payload,
});

export const setActiveJobType = (payload: string): SetActiveJobTypeAction => ({
    type: SET_ACTIVE_JOB_TYPE,
    payload,
});

export const setFilterType = (payload: string): SetFilterTypeAction => ({
    type: SET_FILTER_TYPE,
    payload,
});

export const setSortDirection = (payload: string): SetSortDirectionAction => ({
    type: SET_SORT_DIRECTION,
    payload,
});

export const clearJobListData = (): ClearJobListDataAction => ({
    type: CLEAR_JOB_LIST_DATA,
});

export const destroyDetailsDrawer = (): DestroyDetailsDrawerAction => ({
    type: DESTROY_DETAILS_DRAWER,
});

export const showDetailsDrawer = (payload: string): ShowDetailsDrawerAction => ({
    type: SHOW_DETAILS_DRAWER,
    payload,
});

export const getPhaseConfigList = (): GetPhaseConfigListAction => ({
    type: GET_PHASE_CONFIG_LIST,
});

export const setPhaseConfigList = (payload: PhaseConfigNormalized): SetPhaseConfigListAction => ({
    type: SET_PHASE_CONFIG_LIST,
    payload,
});

export const showConfirmClaimDialog = (payload: JobEntity): ShowConfirmClaimDialogAction => ({
    type: SHOW_CONFIRM_CLAIM_DIALOG,
    payload,
});

export const destroyConfirmClaimDialog = (): DestroyConfirmClaimDialogAction => ({
    type: DESTROY_CONFIRM_CLAIM_DIALOG,
});

export const setFiltersDrawerVisibility = (payload: boolean): SetFiltersDrawerVisibilityAction => ({
    type: SET_FILTERS_DRAWER_VISIBILITY,
    payload,
});

export const toggleInitiateWorkDialog = (payload: Nullable<JobEntity>): ToggleInitiateWorkDialogAction => ({
    type: TOGGLE_INITIATE_WORK_DIALOG,
    payload,
});

export const showActivityNotification = (payload: ActivityNotificationData): ShowActivityNotificationAction => ({
    type: SHOW_ACTIVITY_NOTIFICATION,
    payload,
});

export const resetActivityNotification = (): ResetActivityNotificationAction => ({
    type: RESET_ACTIVITY_NOTIFICATION,
});

export const openJobEditor = (payload: boolean): OpenJobEditorAction => ({
    type: OPEN_JOB_EDITOR,
    payload,
});

export const setJobTestType = (payload: boolean): SetJobTestTypeAction => ({
    type: SET_JOB_TEST_TYPE,
    payload,
});

export const setSelectedFilters = (payload: SelectedFiltersData): SetSelectedFiltersAction => ({
    type: SET_SELECTED_FILTERS,
    payload,
});

export const openExternalJob = (payload: OpenExternalJobData): OpenExternalJobAction => ({
    type: OPEN_EXTERNAL_JOB,
    payload,
});

export const setExternalJobUrl = (payload: Nullable<string>): SetExternalJobUrlAction => ({
    type: SET_EXTERNAL_JOB_URL,
    payload,
});

export const signResource = (payload: SyntheticEvent): SignResourceAction => ({
    type: SIGN_RESOURCE,
    payload,
});

export const getPhaseDirections = (): GetPhaseDirectionsAction => ({
    type: GET_PHASE_DIRECTIONS,
});

export const openCtWebJob = (payload: OpenCtWebJobData): OpenCtWebJobAction => ({
    type: OPEN_CT_WEB_JOB,
    payload,
});

export const setChromeExtensionMissingVisible = (payload: boolean): SetChromeExtensionMissingVisibleAction => ({
    type: SET_CHROME_EXTENSION_MISSING_VISIBLE,
    payload,
});

export const setUnsupportedDomainVisible = (payload: boolean): SetUnsupportedDomainVisibleAction => ({
    type: SET_UNSUPPORTED_DOMAIN_VISIBLE,
    payload,
});
